export interface DatepickerVariables {}

export const datepickerVariables = (siteVariables): DatepickerVariables => ({});
